import { Box, Flex, Image, Text } from "native-base";
import React, { useState, useRef, useEffect } from "react";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import styles from "./styles";
import { useTheme } from "../../../../../ThemeProvider.tsx";

import { RFPercentage } from "react-native-responsive-fontsize";
import { useNavigation, useRoute } from "@react-navigation/native";
import Template from "../../../../template/Index.tsx";
import {
  FlatList,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View,
} from "react-native";
import ModalConfirmacao from "../../../../../components/ModalConfirmacao";
import { Feather, MaterialCommunityIcons } from '@expo/vector-icons'
import TemplateEtapas from "../../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../../template/Etapas/styles";
import {
  corComAlpha,
  corTextoSobre,
  gradienteCard,
} from "../../../../theme/cores";

const PacoteItens: React.FC = () => {
  const { cor_rgba, configEmpresa, primaryColor } = useTheme();

  const refModal = useRef();
  const refModalConfirma = useRef();
  const route = useRoute();
  const navigation = useNavigation();

  const [pacoteSelecionado, setPacoteSelecionado] = useState<any>(null);
  const [setaSelecionaPacote, setSetaSelecionaPacote] = useState<any>(true);

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  );

  useEffect(() => {
    const pacote = route.params?.pacoteSelecionado;

    for (const item of pacote.pacoteVendaItens) {
      item.selecionado = false;
    }

    setPacoteSelecionado(pacote);
  }, []);

  useEffect(() => {
    if (pacoteSelecionado && setaSelecionaPacote) {
      setSetaSelecionaPacote(false);
      const pacoteSelec = pacoteSelecionado.pacoteVendaItens;

      for (const item of pacoteSelec) {
        onPressPacoteSelecionado(item);
      }
    }
  }, [pacoteSelecionado, setaSelecionaPacote]);

  function renderFiltro() {
    return (
      <Box>
        <Text
          style={{
            color: getConfigEmpresa.coresPWA.corFontePrimaria,
            textAlign: "center",
          }}
          fontSize={"md"}
        >
          Escolha abaixo os itens que deseja utilizar
        </Text>
        <Text
          style={{
            color: getConfigEmpresa.coresPWA.corFontePrimaria,
            textAlign: "center",
          }}
          fontSize={"md"}
        >
          {pacoteSelecionado?.pacote.descricao}
        </Text>
      </Box>
    );
  }

  function linhaPacote(item: any) {
    let desabilita = false;

    if (item.produto) {
      desabilita = true;
    }

    if (item.quantidadeUtilizada >= item.quantidade) {
      desabilita = true;
    }

    if (item.ilimitado) {
      desabilita = false;
    }

    return (
      <Flex style={styles.containerFlex}>
        <Box style={styles.leftFlex}>
          <Image
            source={{
              uri: "https://i.pinimg.com/originals/bf/5d/b5/bf5db5425b7823594844b3a110c58e0b.png",
            }}
            alt="Item"
            resizeMode="cover"
            style={styles.imageItem}
          />

          <Box
            style={{
              width: wp("40%"),
            }}
          >
            <Text
              style={[
                styles.itemTextWithMargin,
                { color: getConfigEmpresa.coresPWA.corFontePrimaria },
              ]}
            >
              {item.produto ? item.produto.descricao : item.servico.nome}
            </Text>

            {item.ilimitado && (
              <Text
                style={[
                  styles.itemTextWithMargin,
                  {
                    color: "green",
                    fontSize: RFPercentage(2.3),
                  },
                ]}
              >
                {"Ilimitado"}
              </Text>
            )}

            {!item.ilimitado && (
              <Text
                style={[
                  styles.itemTextWithMargin,
                  {
                    color: "grey",
                  },
                ]}
                fontSize={"sm"}
              >
                {"Qtde Direito: " + item.quantidade}
              </Text>
            )}

            {!item.ilimitado && (
              <Text
                style={[
                  styles.itemTextWithMargin,
                  {
                    color: "grey",
                    fontSize: RFPercentage(2.3),
                  },
                ]}
                fontSize={"sm"}
              >
                {(item.produto ? "Qtde Retirado: " : "Qtde Utilizado: ") +
                  item.quantidadeUtilizada}
              </Text>
            )}

            {item.produto && item.quantidade != item.quantidadeUtilizada && (
              <Text
                style={[
                  styles.itemTextWithMargin,
                  {
                    color: "green",
                    fontSize: RFPercentage(2.3),
                  },
                ]}
              >
                {"Retire seu produto na loja"}
              </Text>
            )}
          </Box>

          <Box
            style={{
              backgroundColor: item.selecionado ? "blue" : "red",
              borderRadius: 10,
            }}
          >
            <Text
              style={{
                color: "#fff",
              }}
            >
              {" "}
              {!item.selecionado ? "Não " : ""}Selecionado{" "}
            </Text>
          </Box>
        </Box>

        {desabilita && <Box style={styles.overlayBox}></Box>}
      </Flex>
    );
  }

  function onPressPacoteSelecionado(item: any) {
    if (!item.ilimitado) {
      if (item.produto) {
        return;
      }

      if (item.quantidadeUtilizada >= item.quantidade) {
        return;
      }
    }

    //setar statusSelecionado como true ou false

    const pacote = pacoteSelecionado;

    const itens = pacote.pacoteVendaItens;

    itens.map((item_) => {
      if (item_.id == item.id) {
        item_.selecionado = !item_.selecionado;
      }
    });

    setPacoteSelecionado({ ...pacote });
  }

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      key={index}
      style={[
        styles.pressableItem,
        {
          borderColor: item.selecionado
            ? cor_rgba ?? "defaultColor"
            : getConfigEmpresa.coresPWA.corBordaItens,
        }, //mais clara
      ]}
      onPress={() => onPressPacoteSelecionado(item)}
    >
      {linhaPacote(item)}
      {/* {buscando ? <SkeletonItens /> : linhaPacote(item)} */}
    </TouchableOpacity>
  );

      
const renderEmptyComponent = () => (
  <Box alignItems="center" justifyContent="center" mt={5}>
    <MaterialCommunityIcons
      name="database-remove"
      size={80}
      color={getConfigEmpresa.coresPWA.corFontePrimaria}
      style={{ marginBottom: 10 }}
    />
    <Text
      style={{
        textAlign: 'center',
        fontSize: RFPercentage(2.5),
        color: getConfigEmpresa.coresPWA.corFontePrimaria
      }}
    >
      Nenhum registro encontrado.
    </Text>
  </Box>
)

  function avancar(mensagemNenhumSelecionado: string) {
    const algum_selecionado = pacoteSelecionado?.pacoteVendaItens.some(
      (item) => {
        return item.selecionado;
      }
    );
    if (!algum_selecionado) {
      refModal.current.abrirModal(mensagemNenhumSelecionado);
      return;
    }

    refModalConfirma.current.abrirModal();
  }

  function renderModalConfirma() {
    return (
      <ModalConfirmacao
        titulo={"Atenção"}
        ref={refModalConfirma}
        mensagem={"Deseja adicionar mais algum serviço?"}
        textoBotaoPositivo={"Sim"}
        textoBotaoNegativo={"Não"}
        onConfirmPositivo={() => {
          if (refModalConfirma.current) {
            refModalConfirma.current.fecharModal();
          }

          const pacotes = [];
          pacotes.push(pacoteSelecionado);

          navigation.navigate("Profissional", {
            pacoteSelecionado: pacotes,
            servicos_adicionais: true,
          });
        }}
        onConfirmNegativo={() => {
          if (refModalConfirma.current) {
            refModalConfirma.current.fecharModal();
          }

          const pacotes = [];
          pacotes.push(pacoteSelecionado);

          navigation.navigate("Profissional", {
            pacoteSelecionado: pacotes,
            servicos_adicionais: false,
          });
        }}
      />
    );
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  function itemDesabilitado(item: any) {
    if (item.ilimitado) return false;
    if (item.produto) return true;
    return item.quantidadeUtilizada >= item.quantidade;
  }

  function formatarValidade(data: string) {
    if (!data) return "";
    const d = new Date(`${data}T00:00:00`);
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    return `${dia}/${mes}/${d.getFullYear()}`;
  }

  function textoStatusItem(item: any) {
    if (item.ilimitado) return "Ilimitado";
    if (item.produto) {
      return item.quantidade != item.quantidadeUtilizada
        ? "Retire seu produto na loja"
        : "Produto já retirado";
    }
    const restantes = Math.max(item.quantidade - item.quantidadeUtilizada, 0);
    return `${restantes} de ${item.quantidade} ${
      restantes === 1 ? "disponível" : "disponíveis"
    }`;
  }

  function renderProgresso(item: any) {
    if (item.ilimitado || !item.quantidade) return null;

    const restantes = Math.max(item.quantidade - item.quantidadeUtilizada, 0);

    return (
      <>
        {item.quantidade <= 12 ? (
          <View style={stylesNovo.segmentos}>
            {Array.from({ length: item.quantidade }).map((_, indice) => (
              <View
                key={indice}
                style={[
                  stylesNovo.segmento,
                  {
                    backgroundColor:
                      indice < restantes ? corPrincipal : "rgba(0,0,0,0.08)",
                  },
                ]}
              />
            ))}
          </View>
        ) : (
          <View style={stylesNovo.barra}>
            <View
              style={{
                width: `${(restantes / item.quantidade) * 100}%`,
                height: "100%",
                borderRadius: 3,
                backgroundColor: corPrincipal,
              }}
            />
          </View>
        )}

        <View style={stylesNovo.linhaQuantidades}>
          <RNText style={stylesNovo.textoQuantidade}>
            {(item.produto ? "Retirados: " : "Utilizados: ") +
              item.quantidadeUtilizada}
          </RNText>
          <RNText style={stylesNovo.textoQuantidade}>
            Direito: {item.quantidade}
          </RNText>
        </View>
      </>
    );
  }

  function renderCardItem(item: any, index: number) {
    const desabilitado = itemDesabilitado(item);
    const selecionado = !!item.selecionado;

    return (
      <TouchableOpacity
        key={item.id ?? index}
        activeOpacity={0.85}
        disabled={desabilitado}
        onPress={() => onPressPacoteSelecionado(item)}
        style={[
          stylesNovo.card,
          sombraCard,
          selecionado && {
            borderColor: corPrincipal,
            backgroundColor: corComAlpha(corPrincipal, 0.06),
          },
          desabilitado && { opacity: 0.5 },
        ]}
      >
        <View style={stylesNovo.linhaItem}>
          <View
            style={[
              stylesNovo.iconeItem,
              { backgroundColor: corComAlpha(corPrincipal, 0.1) },
            ]}
          >
            <Feather
              name={item.produto ? "shopping-bag" : "scissors"}
              size={20}
              color={corPrincipal}
            />
          </View>

          <View style={{ flex: 1 }}>
            <RNText style={stylesNovo.nomeItem}>
              {item.produto ? item.produto.descricao : item.servico.nome}
            </RNText>
            <RNText
              style={[
                stylesNovo.statusItem,
                { color: desabilitado ? CORES.subtitulo : corPrincipal },
              ]}
            >
              {textoStatusItem(item)}
            </RNText>
          </View>

          {!desabilitado && (
            <View
              style={[
                stylesNovo.checkbox,
                selecionado && {
                  backgroundColor: corPrincipal,
                  borderColor: corPrincipal,
                },
              ]}
            >
              {selecionado && (
                <Feather name="check" size={14} color={corTextoPrincipal} />
              )}
            </View>
          )}
        </View>

        {renderProgresso(item)}
      </TouchableOpacity>
    );
  }

  if (!utilizaLayoutLegado) {
    const itens: any[] = pacoteSelecionado?.pacoteVendaItens || [];
    const quantidadeSelecionada = itens.filter((item) => item.selecionado)
      .length;

    return (
      <TemplateEtapas
        ref={refModal}
        rotuloEtapa="Usar pacote"
        titulo={"O que você\nvai usar hoje?"}
        subtitulo="Selecione os itens do pacote para este agendamento."
        onVoltarClick={() => navigation.goBack()}
        resumoRotulo="Selecionado"
        resumoValor={`${quantidadeSelecionada} ${
          quantidadeSelecionada === 1 ? "item" : "itens"
        }`}
        desabilitarBotao={quantidadeSelecionada === 0}
        onBotaoClick={() =>
          avancar("Você precisa selecionar pelo menos um item do pacote.")
        }
      >
        {!!pacoteSelecionado && (
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              borderRadius: 18,
              marginBottom: 22,
              backgroundColor: corPrincipal,
              backgroundImage: gradienteCard(corPrincipal),
              boxShadow: "0 10px 24px rgba(0,0,0,0.16)",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: 140,
                height: 140,
                top: -40,
                right: 40,
                borderRadius: "50%",
                border: "1px solid rgba(255,255,255,0.12)",
                pointerEvents: "none",
              }}
            />
            <View style={stylesNovo.cardPacote}>
              <View style={stylesNovo.iconePacote}>
                <Feather name="package" size={20} color={DOURADO} />
              </View>
              <View style={{ flex: 1 }}>
                <RNText style={stylesNovo.rotuloPacote}>PACOTE</RNText>
                <RNText
                  style={[stylesNovo.nomePacote, { color: corTextoPrincipal }]}
                  numberOfLines={2}
                >
                  {pacoteSelecionado.pacote?.descricao}
                </RNText>
              </View>
              {!!pacoteSelecionado.dataValidade && (
                <View style={{ alignItems: "flex-end" }}>
                  <RNText
                    style={[
                      stylesNovo.rotuloValidade,
                      { color: corTextoPrincipal },
                    ]}
                  >
                    Válido até
                  </RNText>
                  <RNText
                    style={[
                      stylesNovo.dataValidade,
                      { color: corTextoPrincipal },
                    ]}
                  >
                    {formatarValidade(pacoteSelecionado.dataValidade)}
                  </RNText>
                </View>
              )}
            </View>
          </div>
        )}

        <RNText style={stylesNovo.rotuloSecao}>ITENS INCLUÍDOS</RNText>

        {itens.length === 0 ? (
          <View style={stylesNovo.vazio}>
            <Feather name="package" size={40} color={CORES.subtitulo} />
            <RNText style={stylesNovo.textoVazio}>
              Nenhum item neste pacote.
            </RNText>
          </View>
        ) : (
          itens.map((item, index) => renderCardItem(item, index))
        )}

        {renderModalConfirma()}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Direitos do Pacote"}
      onBotaoProximoClick={() =>
        avancar(
          "Você precisa selecionar pelo menos um item, clique em NÃO SELECIONADO para selecionar o item."
        )
      }
      onBotaoVoltarClick={() => {
        navigation.goBack();
      }}
      filtro={renderFiltro()}
      ref={refModal}
    >
      <Box style={styles.mainContainer}>
        <FlatList
          data={pacoteSelecionado?.pacoteVendaItens}
          renderItem={renderItem}
          ListEmptyComponent={renderEmptyComponent}
          // ListEmptyComponent={buscando ? <SkeletonItens /> : renderEmptyComponent}
          keyExtractor={(item, index) => index.toString()}
          contentContainerStyle={{
            width: wp("98%"),
          }}
        />
      </Box>

      {renderModalConfirma()}
    </Template>
  );
};

const DOURADO = "#E3BF7A";

const stylesNovo = StyleSheet.create({
  cardPacote: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 16,
  },
  iconePacote: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: "rgba(255,255,255,0.12)",
    alignItems: "center",
    justifyContent: "center",
  },
  rotuloPacote: {
    color: DOURADO,
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
  },
  nomePacote: {
    fontSize: 20,
    fontWeight: "800",
  },
  rotuloValidade: {
    fontSize: 11,
    opacity: 0.8,
  },
  dataValidade: {
    fontSize: 14,
    fontWeight: "800",
  },
  rotuloSecao: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
    color: CORES.subtitulo,
    marginBottom: 12,
  },
  card: {
    padding: 14,
    marginBottom: 12,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1.5,
    borderColor: "transparent",
  },
  linhaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  iconeItem: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  nomeItem: {
    fontSize: 16,
    fontWeight: "700",
    color: CORES.titulo,
  },
  statusItem: {
    fontSize: 12,
    fontWeight: "600",
    marginTop: 2,
  },
  checkbox: {
    width: 22,
    height: 22,
    borderRadius: 6,
    borderWidth: 1.5,
    borderColor: "#cfcfcf",
    alignItems: "center",
    justifyContent: "center",
  },
  segmentos: {
    flexDirection: "row",
    gap: 4,
    marginTop: 14,
  },
  segmento: {
    flex: 1,
    height: 5,
    borderRadius: 3,
  },
  barra: {
    height: 6,
    borderRadius: 3,
    marginTop: 14,
    backgroundColor: "rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  linhaQuantidades: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
  },
  textoQuantidade: {
    fontSize: 12,
    color: CORES.subtitulo,
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
  },
});

export default PacoteItens;
